import scrollIntoViewNeeded from "scroll-into-view-if-needed";
import { cancelRaf, FRAME_TIME, raf } from "./requestAnimationFrame.mjs";
const PADDING_TOP = 16;
const scrollDirectionMapper = {
  left: "scrollLeft",
  top: "scrollTop"
};
export const scrollTo = (options) => {
  const { element, direction, to, duration } = options;
  let rafId = 0;
  let count = 0;
  const scrollDirection = scrollDirectionMapper[direction];
  const from = element[scrollDirection];
  const frames = duration === 0 ? 1 : Math.round(duration / FRAME_TIME);
  const animate = () => {
    element[scrollDirection] += (to - from) / frames;
    if (++count < frames)
      rafId = raf(animate);
  };
  cancelRaf(rafId);
  animate();
};
export const scrollIntoView = (el, offsetTop = 0, duration = 0) => {
  const element = document.querySelector(el);
  if (!element)
    return;
  scrollIntoViewNeeded(element, {
    scrollMode: "if-needed",
    inline: "nearest",
    block: "start",
    behavior(actions) {
      actions.forEach(({ el: el2, top }) => {
        const to = top - PADDING_TOP - offsetTop;
        scrollTo({
          element: el2,
          direction: "top",
          duration,
          to
        });
      });
    }
  });
};
export const scrollLeftTo = (scroller, to, duration) => {
  scrollTo({
    element: scroller,
    direction: "left",
    to,
    duration
  });
};
